import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;

  > label {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  > span {
    font-size: 0.75rem;
    font-weight: 500;
    display: flex;
    align-self: flex-end;
    padding: 0.5rem 0.5rem 0 0.5rem;
  }
`;
